/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-03-30T14:13:40.963Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'milf'

export default NICHE
